import { gql } from '@apollo/client';

export const fragments = {
  m: gql`
    fragment SignalLogData on SignalLog {
      id
      gatewayId
      braceletId
      signalStrength
      receivedAt
    }
  `,
  all: gql`
    fragment RoomDataAll on Room {
      id
      gatewayId
      braceletId
      signalStrength
      receivedAt
      beaconTimestamp
      gatewayTimestamp
    }
  `,
};

export const signalLogForPatient = gql`
  query signalLogForPatient($patientId: Long!) {
    signalLogForPatient(patientId: $patientId) {
      ...SignalLogData
    }

    allGateways {
      id
      room {
        name
      }
      threshold
    }
  }
  ${fragments.m}
`;

export const signalProcessing = {
  item: gql`
    query gwConfig {
      signalProcessingConfig {
        id
        swPeriod
        useWattAveraging
        useAveragingStage
        minimumSamples
        staffMinimumSamples
        staffSwPeriod
        timeToAnnounceChange
        timeToAnnounceOffsite
      }
    }
  `,
  setSlidingWindowPeriod: gql`
    mutation setSlidingWindowPeriod($swPeriod: Long!) {
      setSlidingWindowPeriod(swPeriod: $swPeriod) {
        id
        swPeriod
        useWattAveraging
        useAveragingStage
        minimumSamples
        staffMinimumSamples
        staffSwPeriod
        timeToAnnounceChange
        timeToAnnounceOffsite
      }
    }
  `,
  setUseWattAveraging: gql`
    mutation setUseWattAveraging($useWattAveraging: Boolean!) {
      setUseWattAveraging(useWattAveraging: $useWattAveraging) {
        id
        swPeriod
        useWattAveraging
        useAveragingStage
        minimumSamples
        staffMinimumSamples
        staffSwPeriod
        timeToAnnounceChange
        timeToAnnounceOffsite
      }
    }
  `,
  setUseAveragingStage: gql`
    mutation setUseAveragingStage($useAveragingStage: Boolean!) {
      setUseAveragingStage(useAveragingStage: $useAveragingStage) {
        id
        swPeriod
        useWattAveraging
        useAveragingStage
        minimumSamples
        staffMinimumSamples
        staffSwPeriod
        timeToAnnounceChange
        timeToAnnounceOffsite
      }
    }
  `,
  setMinimumSamples: gql`
    mutation setMinimumSamples($minimumSamples: Int!) {
      setMinimumSamples(minimumSamples: $minimumSamples) {
        id
        swPeriod
        useWattAveraging
        useAveragingStage
        minimumSamples
        staffMinimumSamples
        staffSwPeriod
        timeToAnnounceChange
        timeToAnnounceOffsite
      }
    }
  `,
  setStaffSlidingWindowPeriod: gql`
    mutation setStaffSlidingWindowPeriod($swPeriod: Long!) {
      setStaffSlidingWindowPeriod(swPeriod: $swPeriod) {
        id
        swPeriod
        useWattAveraging
        useAveragingStage
        minimumSamples
        staffMinimumSamples
        staffSwPeriod
        timeToAnnounceChange
        timeToAnnounceOffsite
      }
    }
  `,
  setStaffMinimumSamples: gql`
    mutation setStaffMinimumSamples($minimumSamples: Int!) {
      setStaffMinimumSamples(minimumSamples: $minimumSamples) {
        id
        swPeriod
        useWattAveraging
        useAveragingStage
        minimumSamples
        staffMinimumSamples
        staffSwPeriod
        timeToAnnounceChange
        timeToAnnounceOffsite
      }
    }
  `,
  setTimeToAnnounceChange: gql`
    mutation setTimeToAnnounceChange($timeToAnnounceChange: Int!) {
      setTimeToAnnounceChange(timeToAnnounceChange: $timeToAnnounceChange) {
        id
        swPeriod
        useWattAveraging
        useAveragingStage
        minimumSamples
        staffMinimumSamples
        staffSwPeriod
        timeToAnnounceChange
        timeToAnnounceOffsite
      }
    }
  `,
  setTimeToAnnounceOffsite: gql`
    mutation setTimeToAnnounceOffsite($timeToAnnounceOffsite: Int!) {
      setTimeToAnnounceOffsite(timeToAnnounceOffsite: $timeToAnnounceOffsite) {
        id
        swPeriod
        useWattAveraging
        useAveragingStage
        minimumSamples
        staffMinimumSamples
        staffSwPeriod
        timeToAnnounceChange
        timeToAnnounceOffsite
      }
    }
  `,
};
